module.exports = __webpack_public_path__ + "img/T3.b33baa28.png";